var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"lm-image",class:{
  'is_shadow': _vm.shadow
},style:({
  height: _vm.height
}),on:{"click":function($event){return _vm.$emit('click')}}},[_c('section',{staticClass:"lm-image_content"},[_c('img',{ref:"content",class:['is_block', {
      'is_scale': _vm.scale
    }],style:(_vm.position),attrs:{"src":_vm.src}})]),_c('section',{staticClass:"lm-image_text"},[_c('div',{staticClass:"lm-image_title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"lm-image_intro"},[_vm._v(_vm._s(_vm.description))])]),_c('div',{staticClass:"title-cen"},[_vm._t("title")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }